<template>
  <div class="tw-m-auto xl:tw-w-[1200px] xl:tw-px-0">
    <slot></slot>
  </div>
</template>
